<template>
<div class="cardContainerChild clearfix" :class="info.online==false?'active':info.alarm?'active1':'active2'">
  <div class="text">
    <div class="titleMess" :class="setSSid(info.ssid)==0?'act0':setSSid(info.ssid)==1?'act1':setSSid(info.ssid)==2?'act2':setSSid(info.ssid)==3?'act3':setSSid(info.ssid)==4?'act4':''">
      <h4 :title="info.name" @click="$emit('clickEven',info)">{{info.name}}</h4>
      <!-- <div class="ssidMess">
        <div class="mess0 common"></div>
        <div class="mess1 common"></div>
        <div class="mess2 common"></div>
        <div class="mess3 common"></div>
        <div class="mess4 common"></div>
      </div> -->
    </div>
    <div class="infoList">
      <dl>
        <dd>
          <div class="mess messOther" :style="{'width':info.online == false?'210px':'130px'}" :title="info.code">{{info.code}}</div>
          <div class="mess messOnline" :class="[info.online == true ? 'normal' : 'abnormal']">
            <i></i><span>{{info.online?'在线':'离线'}}</span>
          </div>
          <div class="mess messAlarm" :class="[info.alarm == false ? 'normal' : 'abnormal']" v-if="info.online == true">
            <i></i><span>{{!info.alarm?'正常':'报警中'}}</span>
          </div>
        </dd>
        <dd>
          <div class="title">
            <div class="outer">
              <div class="inner">
                <span :title="info.type=='CH4'?'甲烷':info.type=='NH3'?'氨气':info.type=='H2S'?'硫化氢':info.type=='CO'?'一氧化碳':info.type=='Temperature'?'温度':info.type=='Humidity'?'湿度':info.type=='Vlotage'?'电压':info.type=='Relay'?'继电器':info.type=='PID'?'PID':info.type">
                  {{info.type=='CH4'?'甲烷':info.type=='NH3'?'氨气':info.type=='H2S'?'硫化氢':info.type=='CO'?'一氧化碳':info.type=='Temperature'?'温度':info.type=='Humidity'?'湿度':info.type=='Vlotage'?'电压':info.type=='Relay'?'继电器':info.type=='PID'?'PID':info.type}}
                </span>
              </div>
            </div>
            <p class="device-status">状态：{{info.status}}</p>
          </div>
          <div class="values">
            <span :title="info.value">{{info.value}}</span>
          </div>
          <div class="unit">
            <span :title="info.unit">{{info.unit}}</span>
          </div>
        </dd>
      </dl>
    </div>
  </div>
  <div class="handleBtns">
    <div class="gotoChild">
      <div class="tip">
        <el-tooltip class="item" effect="light" :content="info.installLocation?info.installLocation:'无'" placement="bottom" :popper-class="info.online==false?'activeGray setColor':info.alarm?'activeRed setColor':'activeGreen setColor'">
          <el-button :class="info.online==false?'activeGrayMess':info.alarm?'activeRedMess':'activeGreenMess'">
            <i class="commonImg imgBox"><img src="../../../assets/img/gateway/positionChild.png" alt=""></i>
            <i class="commonImg imgBox1"><img src="../../../assets/img/gateway/positionChildGray.png" alt=""></i>
            <i class="commonImg imgBox2"><img src="../../../assets/img/gateway/positionChildGreen.png" alt=""></i>
            <i class="commonImg imgBox3"><img src="../../../assets/img/gateway/positionChildRed.png" alt=""></i>
            <span class="tit">安装位置</span>
          </el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="light" :content="info.updateTime?info.updateTime:'无'" placement="bottom" :popper-class="info.online==false?'activeGray setColor':info.alarm?'activeRed setColor':'activeGreen setColor'">
          <el-button :class="info.online==false?'activeGrayMess':info.alarm?'activeRedMess':'activeGreenMess'">
            <i class="commonImg imgBox"><img src="../../../assets/img/gateway/timeChild.png" alt=""></i>
            <i class="commonImg imgBox1"><img src="../../../assets/img/gateway/timeChildGray.png" alt=""></i>
            <i class="commonImg imgBox2"><img src="../../../assets/img/gateway/timeChildGreen.png" alt=""></i>
            <i class="commonImg imgBox3"><img src="../../../assets/img/gateway/timeChildRed.png" alt=""></i>
            <span class="tit">更新时间</span>
          </el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="light" content="" placement="bottom" disabled :popper-class="info.online==false?'activeGray setColor':info.alarm==false?'activeRed setColor':'activeGreen setColor'">
          <el-button :class="info.online==false?'activeGrayMess':info.alarm?'activeRedMess':'activeGreenMess'">
            <i class="commonImg imgBox"><img src="../../../assets/img/gateway/delChild.png" alt=""></i>
            <i class="commonImg imgBox1"><img src="../../../assets/img/gateway/delChildGray.png" alt=""></i>
            <i class="commonImg imgBox2"><img src="../../../assets/img/gateway/delChildGreen.png" alt=""></i>
            <i class="commonImg imgBox3"><img src="../../../assets/img/gateway/delChildRed.png" alt=""></i>
            <span class="tit" @click="delDevice(info.id)">拆除设备</span>
          </el-button>
        </el-tooltip>
      </div>
    </div>
  </div>
  <div class="delDeviceDialog">
    <el-dialog
      title="子设备历史数据"
      :visible.sync="dialogVisible"
      width="420px">
      <span>是否删除：</span>
      <el-select class="common" v-model="deleteMess" placeholder="是否故障">
        <el-option label="是" :value="true"></el-option>
        <el-option label="否" :value="false"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisibleEven">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    who: {
      type: String,
      default: ''
    },
    handles: {
      type: Array,
      default: () => {
        return ['details', 'edit', 'del']
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return{
      dialogVisible:false,
      deleteMess:false,
      childrenId:null
    }
  },
  created() {
    // console.log(this.who)
    // console.log(this.info);
  },
  methods: {
    setSSid(val){
      if(0<val&&val<8){
        return 0
      } else if(7<val&&val<18){
        return 1
      } else if(17<val&&val<23){
        return 2
      } else if(22<val&&val<28){
        return 3
      } else if(27<val&&val<32){
        return 4
      } else {
        return 0
      }
    },
    delDevice(val){
      // console.log(val);
      this.dialogVisible=true
      this.childrenId = val
    },
    dialogVisibleEven(){
      this.dialogVisible = false
      let params = {
        delete : this.deleteMess
      }
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          this.request.delete("/front/device/gateway/child/" + this.childrenId,params).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.$emit('changeCards',true)
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.cardContainerChild {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px 0px 30px 0px rgba(220, 236, 248, 0.69);
  border-radius: 2px;
  background: #fff;
  position: relative;

  .device-status {
    font-size: 12px;
    border: 1px solid #999B9E;
    padding: 1px 2px;
    border-radius: 10px;
    margin-top: 5px;
    max-width: 94px;
  }

  &.active {
    border-top: 3px #B8BABC solid;

    .text {
      .titleMess{
        h4 {
          color: #999B9E;
        }
        .ssidMess{
          .common{
            background: #D6D7D8;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
            .mess1{
              background: #999B9E;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #999B9E;
            }
            .mess1{
              background: #999B9E;
            }
            .mess2{
              background: #999B9E;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #999B9E;
            }
            .mess4{
              background: #D6D7D8;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #999B9E;
            }
          }
        }
      }
    }

    .text .infoList {
      dl {
        dd {
          width: 100%;
          .title{
            .outer{
              border: 3px solid #999B9E;
              background: #EEEFEF;
              .inner{
                span{
                  color: #999B9E;
                }
              }
            }
          }
          .values{
            span{
              color: #999B9E;
            }
          }
          .unit{
            span{
              color: #999B9E;
            }
          }
        }
      }
    }
  }

  &.active1 {
    border-top: 3px #F43300 solid;

    .text {
      .titleMess{
        h4 {
          color: #F43300;
        }
        .ssidMess{
          .common{
            background: #FBC1B2;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
            .mess1{
              background: #F43300;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #F43300;
            }
            .mess1{
              background: #F43300;
            }
            .mess2{
              background: #F43300;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #F43300;
            }
            .mess4{
              background: #FBC1B2;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #F43300;
            }
          }
        }
      }
    }

    .text .infoList {
      dl {
        dd {
          width: 100%;
          .title{
            .outer{
              border: 3px solid #F43300;
              background: #FDEAE5;
              .inner{
                span{
                  color: #F43300;
                }
              }
            }
          }
          .values{
            span{
              color: #F43300;
            }
          }
          .unit{
            span{
              color: #F43300;
            }
          }
        }
      }
    }
  }

  &.active2 {
    border-top: 3px #08BB80 solid;
    .text {
      .titleMess{
        .ssidMess{
          .common{
            background: #B4EAD8;
          }
        }
        &.act0{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
          }
        }
        &.act1{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
            .mess1{
              background: #08BB80;
            }
          }
        }
        &.act2{
          .ssidMess{
            .mess0{
              background: #08BB80;
            }
            .mess1{
              background: #08BB80;
            }
            .mess2{
              background: #08BB80;
            }
          }
        }
        &.act3{
          .ssidMess{
            .common{
              background: #08BB80;
            }
            .mess4{
              background: #B4EAD8;
            }
          }
        }
        &.act4{
          .ssidMess{
            .common{
              background: #08BB80;
            }
          }
        }
      }
    }
    .text .infoList {
      dl {
        dd {
          width: 100%;
          .title{
            .outer{
              border: 3px solid #08BB80;
              background: #E6F8F2;
              .inner{
                span{
                  color: #08BB80;
                }
              }
            }
          }
          .values{
            span{
              color: #08BB80;
            }
          }
          .unit{
            span{
              color: #08BB80;
            }
          }
        }
      }
    }
  }

  .img {
    position: absolute;
    top: 25px;
    left: 20px;
    width: 150px;
    height: 150px;
  }

  .text {
    width: 100%;
    padding: 14px 14px 0 14px;
    box-sizing: border-box;
    .titleMess{
      overflow: hidden;
      position: relative;
      h4 {
        float: left;
        width: 230px;
        height: 24px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: "AlibabaPuHuiTi-Bold";
      }
      .ssidMess{
        width: 30px;
        float: right;
        .common{
          position: absolute;
          width: 3px;
          background: #D6D7D8;
          bottom: 4px;
        }
        .mess0{
          height: 4px;
          margin-left: 0;
          right: 24px;
        }
        .mess1{
          height: 7px;
          right: 18px;
        }
        .mess2{
          height: 10px;
          right: 12px;
        }
        .mess3{
          height: 13px;
          right: 6px;
        }
        .mess4{
          height: 16px;
          right: 0;
        }
      }
    }

    .infoList {
      // height: 75px;
      margin: 10px 0;
      font-size: 0;
      font-family: AlibabaPuHuiTi-Medium;

      dl {
        overflow: hidden;

        dd {
          float: left;
          width: 100%;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
          letter-spacing: 1px;
          overflow: hidden;
          &:nth-child(2){
            margin-top: 5px;
          }
          .title{
            float: left;
            text-align: center;
            .outer{
              display: inline-block;
              width: 60px;
              height: 60px;
              line-height: 60px;
              border: 3px solid #FDEAE5;
              background: #FDEAE5;
              // box-sizing: border-box;
              border-radius: 50%;
              text-align: center;
              .inner{
                width: 100%;
                height: 100%;
                border-radius: 50%;
                span{
                  display: inline-block;
                  width: 100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
          .values{
            width: 100px;
            margin-left: 10px;
            float: left;
            text-align: center;
            height:66px;
            line-height: 66px;
            span{
              width: 100%;
              display: inline-block;
              font-size: 40px;
              font-family: GoogleSans-Bold;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .unit{
            margin-left: 5px;
            width: 50px;
            float: left;
            text-align: center;
            height: 66px;
            line-height: 66px;
            span{
              display: inline-block;
              width: 100%;
              font-size: 18px;
              font-family: AlibabaPuHuiTi-Medium;
              font-weight: 500;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .messOther {
            text-align: left;
            width: 130px;
            font-family: AlibabaPuHuiTi-Medium;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .mess {
            display: inline-block;
            // width: 80px;
            height: 26px;
            border-radius: 13px;
            overflow: hidden;
            line-height: 26px;

            i {
              float: left;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin: 10px 10px 0 10px;
            }

            span {
              float: left;
            }
            &.messAlarm {
              &.normal {
                // background: #E6F8F2;
                color: #08BB80;

                i {
                  background: #08BB80;
                }
              }

              &.abnormal {
                // background: #FDEAE5;
                color: #F43300;

                i {
                  background: #F43300;
                }
              }
            }

            &.messOnline {
              &.normal {
                // background: #E7F3FF;
                color: #1089FF;

                i {
                  background: #1089FF;
                }
              }

              &.abnormal {
                // background: #EEEFEF;
                color: #999B9E;

                i {
                  background: #999B9E;
                }
              }
            }
          }
        }
      }
    }
  }

  .handleBtns {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    // padding: 10px;
    left: 0;
    bottom: 0;
    z-index: 1;
    .gotoChild {
      width: 100%;
      overflow: hidden;
      border-radius: 2px;
      height: 36px;
      // padding: 0 10px;
      box-sizing: border-box;

      .activeGrayMess {
        &.item{
          background:#fff;
        }
        &:hover{
          .imgBox{
            display: none;
          }
          .imgBox1{
            display: block;
          }
          .tit {
            color: #999B9E;
          }
        }
      }

      .activeGreenMess {
        &.item{
          background:#fff;
        }
        &:hover{
          .imgBox{
            display: none;
          }
          .imgBox2{
            display: block;
          }
          .tit {
            color: #08BB80;
          }
        }
      }

      .activeRedMess {
        &.item{
          background:#fff;
        }
        &:hover{
          .imgBox{
            display: none;
          }
          .imgBox3{
            display: block;
          }
          .tit {
            color: #F43300;
          }
        }
      }

      .tip {
        float: left;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        line-height: 36px;
        b {
          font-weight: 500;
        }
      }

    }
  }
}
</style>
<style lang="scss">
.setColor{
  &.activeGray {
    color: #999B9E;
    &.el-tooltip__popper.is-light{
      background: #EEEFEF;
      box-shadow: 0px 2px 20px 0px rgba(51, 56, 62, 0.05);
      filter: blur(0px);
      border: none;
      .popper__arrow{
        border: none;
        &::after{
          border-bottom:5px solid rgba(51, 56, 62, 0.05);
        }
      }
    }
  }

  &.activeGreen {
    color: #08BB80;
    &.el-tooltip__popper.is-light{
      background: #defff5;
      box-shadow: 0px 2px 20px 0px rgba(8,187,128, 0.07);
      filter: blur(0px);
      border: none;
      .popper__arrow{
        border: none;
        &::after{
          border-bottom:5px solid rgba(8,187,128, 0.07);
        }
      }
    }
  }

  &.activeRed {
    color: #F43300;
    &.el-tooltip__popper.is-light{
      background: #FDEAE5;
      box-shadow: 0px 2px 20px 0px rgba(244, 51, 0, 0.07);
      filter: blur(0px);
      border: none;
      .popper__arrow{
        border: none;
        &::after{
          border-bottom:5px solid rgba(244, 51, 0, 0.07);
        }
      }
    }
  }
}
.cardContainerChild{
  .handleBtns{
    i{
      img{
        width: 100%;
        height: 100%;
      }
    }
    .el-button{
      padding: 0 10px;
      margin: 0;
      border: none;
      border-radius: unset;
      border-right: 1px solid #7A7D81;
      &:last-child{
        border-right: none;
      }
    }
    .item{
      overflow: hidden;
      .commonImg{
        float: left;
        width: 14px;
        height: 14px;
        margin-right: 4px;
        img{
          width: 100%;
          height: 100%;
          vertical-align: middle;
          border: none;
        }
        &.imgBox1{
          display: none;
        }
        &.imgBox2{
          display: none;
        }
        &.imgBox3{
          display: none;
        }
      }
      .tit{
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        color: #7A7D81;
      }
    }
  }
}
.delDeviceDialog{
  .el-dialog{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -210px;
    margin-top: -93px !important;
    .el-button{
      padding: 9px 15px;
      color: #FFF;
      background-color: #409EFF;
      border-color: #409EFF;
      border-radius: 3px;
      span{
        font-size: 12px;
      }
    }
    .el-select{
      .el-input{
        .el-select__caret{
          &.el-input__icon{
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
